// @needsAudit
export type DetectionResult = {
  /**
   * A boolean indicating whether the image is NSFW or not.
   */
  isNSFW: boolean;
  /**
   * Confidence of the result. Range is 0.0 to 1.0.
   */
  confidence: number;
};
